import React from 'react';
import { formatValue } from './DataTableCard';

const SEVERITY_STYLES = {
  critical: { bg: 'bg-red-50', border: 'border-red-300', text: 'text-red-800', badge: 'bg-red-100 text-red-700', icon: '🚨' },
  warning:  { bg: 'bg-amber-50', border: 'border-amber-300', text: 'text-amber-800', badge: 'bg-amber-100 text-amber-700', icon: '⚠️' },
  info:     { bg: 'bg-blue-50', border: 'border-blue-300', text: 'text-blue-800', badge: 'bg-blue-100 text-blue-700', icon: 'ℹ️' },
};

const AnomalyAlertCard = ({ card }) => {
  if (!card || !card.alerts || card.alerts.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 shadow-sm w-full mt-3">
      {card.title && (
        <div className="text-xs font-semibold text-gray-700 mb-3">{card.title}</div>
      )}
      <div className="space-y-2">
        {card.alerts.slice(0, 4).map((alert, i) => {
          const s = SEVERITY_STYLES[alert.severity] || SEVERITY_STYLES.info;
          const format = /roas/i.test(alert.metric) ? 'multiplier' : /revenue|spend|cost/i.test(alert.metric) ? 'currency' : 'number';
          return (
            <div key={i} className={`${s.bg} ${s.border} border rounded-lg p-3`}>
              <div className="flex items-start gap-2">
                <span className="text-sm flex-shrink-0">{s.icon}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`${s.badge} px-1.5 py-0.5 rounded text-[9px] font-bold uppercase`}>
                      {alert.severity}
                    </span>
                    <span className={`${s.text} text-[11px] font-semibold`}>{alert.metric}</span>
                  </div>
                  <div className={`${s.text} text-[11px]`}>{alert.message}</div>
                  {alert.possibleCause && (
                    <div className="text-[10px] text-gray-500 mt-1">
                      Possible cause: {alert.possibleCause}
                    </div>
                  )}
                  <div className="flex items-center gap-3 mt-1.5 text-[10px] text-gray-600">
                    <span>Current: {formatValue(alert.current, format, alert.metric)}</span>
                    <span>Previous: {formatValue(alert.previous, format, alert.metric)}</span>
                    {alert.changePct != null && (
                      <span className={alert.changePct >= 0 ? 'text-green-600' : 'text-red-600'}>
                        {alert.changePct >= 0 ? '+' : ''}{Number(alert.changePct).toFixed(1)}%
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {card.period && (
        <div className="mt-3 text-[10px] text-gray-400 text-right font-mono">
          {card.period.start} &rarr; {card.period.end}
        </div>
      )}
    </div>
  );
};

export default AnomalyAlertCard;
